export default __webpack_public_path__ + "static/media/lookback.c1fc34bf.svg";